module.exports = __webpack_public_path__ + "59d2782456a7cdaa7b1d5fba39ec3161.svg";